import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import { orderApi, userSession } from "../services";
import { formatMoney } from "../utils/utils";

function OrderHistoryPage({ onNavigate }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    // Check if user is logged in and has user info
    const userInfoData = localStorage.getItem("user_info");
    if (userInfoData) {
      try {
        const userData = JSON.parse(userInfoData);
        setUserInfo(userData);
        // Auto load orders using logged in user's phone
        loadOrders(); // username is phone number
      } catch (error) {
        console.error("Error parsing user info:", error);
        setError("Vui lòng đăng nhập để xem lịch sử đơn hàng");
      }
    } else {
      setError("Vui lòng đăng nhập để xem lịch sử đơn hàng");
    }
  }, []);

  const loadOrders = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await orderApi.getOrdersByMobile();
      console.log(response);

      if (response.ok && Array.isArray(response.payload)) {
        setOrders(response.payload);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error loading orders:", error);
      setError("Không thể tải danh sách đơn hàng. Vui lòng thử lại.");
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      // Hiển thị cả ngày và giờ
      return date.toLocaleString("vi-VN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateString;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "#7ED957";
      case 2:
        return "#F9A23B";
      case 2:
        return "#ff4444";
      default:
        return "#888";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 2:
        return "Đã check-out";
      case 0:
        return "Đã check-in";
      case 3:
        return "Đã hủy";
      default:
        return status || "Không xác định";
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: 40,
      }}
    >
      <div
        style={{
          background: "#fff",
          width: 340,
          minHeight: 600,
          borderRadius: 8,
          padding: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Header
          onCartClick={() => onNavigate && onNavigate(-1)}
          onMenuClick={() => onNavigate && onNavigate("/")}
        />

        <div
          style={{
            width: "100%",
            fontWeight: 700,
            fontSize: 20,
            margin: "16px 0 24px 0",
            color: "#5b6754",
          }}
        >
          Lịch sử đơn hàng
          {userInfo && (
            <div style={{ fontSize: 14, fontWeight: 400, color: '#666', marginTop: 4 }}>
              {userInfo.name} ({userInfo.username})
            </div>
          )}
        </div>

        {/* Error Section */}
        {error && (
          <div style={{ 
            color: '#ff4444', 
            fontSize: 14, 
            marginBottom: 16,
            textAlign: 'center',
            background: '#fee',
            border: '1px solid #fcc',
            borderRadius: 8,
            padding: '12px 16px'
          }}>
            {error}
          </div>
        )}


        {/* Orders List */}
        <div style={{ width: "100%", flex: 1 }}>
          {loading && (
            <div
              style={{ textAlign: "center", padding: "40px 0", color: "#888" }}
            >
              Đang tải danh sách đơn hàng...
            </div>
          )}

          {!loading && orders.length === 0 && !error && (
            <div
              style={{ textAlign: "center", padding: "40px 0", color: "#888" }}
            >
              Bạn chưa có đơn hàng nào
            </div>
          )}

          {!loading &&
            orders.length > 0 &&
            orders.map((order) => (
              <div
                key={order.order_id || order.id}
                style={{
                  background: "#f8f8f8",
                  borderRadius: 12,
                  padding: 16,
                  marginBottom: 18,
                  boxShadow: "0 2px 8px rgba(91,103,84,0.04)",
                  cursor: "pointer",
                }}
                onClick={() =>
                  onNavigate(`order-detail/${order.order_id || order.id}`)
                }
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                  }}
                >
                  <div style={{ fontWeight: 600 }}>
                    {order.order_code || order.id}
                  </div>
                  <div style={{ color: "#888", fontSize: 14 }}>
                    {formatDate(
                      order.created_datetime || order.created_at || order.date
                    )}
                  </div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  {order.list_products && order.list_products.length > 0 ? (
                    order.list_products.map((item, idx) => (
                      <span key={idx} style={{ fontSize: 15, marginRight: 12 }}>
                        {item.name}{" "}
                        <span style={{ color: "#888" }}>x{item.quantity}</span>
                      </span>
                    ))
                  ) : order.items ? (
                    order.items.map((item, idx) => (
                      <span key={idx} style={{ fontSize: 15, marginRight: 12 }}>
                        {item.name}{" "}
                        <span style={{ color: "#888" }}>
                          x{item.qty || item.quantity}
                        </span>
                      </span>
                    ))
                  ) : (
                    <span style={{ fontSize: 15, color: "#888" }}>
                      Không có thông tin sản phẩm
                    </span>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      color: getStatusColor(order?.status),
                      fontWeight: 600,
                    }}
                  >
                    {getStatusText(order?.status)}
                  </div>
                  <div
                    style={{ fontWeight: 600, color: "#5b6754", fontSize: 16 }}
                  >
                    {order.total_amount
                      ? formatMoney(parseFloat(order.total_amount))
                      : formatMoney(order.total || 0)}
                    đ
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default OrderHistoryPage;
